var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSnack = function SvgSnack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#snack_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M58.38 26.941s.611-1.376.613-1.45c.015-.021 0-2.877.005-2.903.009-.39-.412-.693-.78-.553l-1.829.639-1.828-.64a.6.6 0 0 0-.387.001l-1.826.639-1.826-.639a.57.57 0 0 0-.387 0l-1.825.639-1.822-.639a.58.58 0 0 0-.388 0l-1.825.639-1.825-.639a.57.57 0 0 0-.387 0l-1.825.639-1.822-.639c-.366-.138-.791.16-.78.553v2.877c.013.081 1.067 2.28 1.02 3.318v14.594h-6.9c-1.067.026-2.17-.242-3.181-.461-.042.003-2.986-.013-2.986-.013-.465-.016-.765.573-.47.938l.44.586c-.209.324-.813.838-.44 1.29l.441.588c-.203.317-.817.834-.44 1.292l.44.586c-.19.303-.82.829-.44 1.29l.44.588-.44.589c-.361.45.201.942.44 1.292l-.44.59c-.289.362-.003.954.469.937h2.863c1.065-.206 2.186-.5 3.305-.474 1.23.101 15.777-.213 16.53.198l1.224.263c.041.009 2.987.013 2.987.013a.59.59 0 0 0 .525-.324c.25-.415-.292-.893-.496-1.203.236-.358.805-.834.44-1.292l-.44-.589.274-.365 1.37.483a.6.6 0 0 0 .39 0l1.828-.643 1.829.644a.588.588 0 0 0 .78-.553v-2.878c-.009-.082-1.054-2.262-1.018-3.32V28.783c0-.639.138-1.275.4-1.842m-18.335-3.093a.58.58 0 0 0 .387 0l1.825-.639 1.825.64a.57.57 0 0 0 .387 0l1.825-.64 1.822.64a.58.58 0 0 0 .388 0l1.825-.64 1.825.64a.57.57 0 0 0 .387 0l1.826-.64 1.83.64c.124.043.26.043.386 0l1.243-.435v1.463H38.808v-1.462zm-.723 2.605-.185-.404H57.5c-.424.845-.702 1.77-.692 2.734V43.43c-.01.967.269 1.892.692 2.735h-4.866c.242-.325.66-.735.334-1.15l-.44-.586.44-.587c.293-.366 0-.952-.47-.937h-2.863c-.024 0-1.346.275-1.346.275-1.335.366-7.002.141-8.46.199V28.784c0-.791-.174-1.596-.506-2.33m-12.56 25.138L26.32 51l.44-.589a.59.59 0 0 0 0-.703l-.44-.588.44-.588c.364-.448-.203-.943-.44-1.289.238-.35.804-.836.44-1.29l-.44-.588.44-.587a.59.59 0 0 0 0-.703h1.105v8.22H26.76a.59.59 0 0 0 .003-.705m21.77.456a10.5 10.5 0 0 0-2.202-.225c-1.491.086-15.702-.222-16.776.225l-.515.11v-7.944l.515.11c1.014.453 15.343.138 16.776.226.95.007 1.833-.13 2.718-.336v7.944zm2.794-1.635.44.589-.44.59a.586.586 0 0 0 .002.706h-1.107v-8.222h1.105c-.364.45.204.943.44 1.291l-.44.588c-.364.449.203.943.44 1.29l-.44.587c-.365.448.204.944.44 1.29-.237.351-.804.837-.44 1.292m5.258-2.05a.58.58 0 0 0-.39 0l-1.828.643-1.662-.587-.176-.235c.117-.172.534-.634.542-.847h4.756v1.463z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M46.201 46.084H32.134a.586.586 0 0 0-.586.586v2.992c0 .325.262.587.586.587h14.067a.586.586 0 0 0 .586-.587V46.67a.586.586 0 0 0-.586-.586m-.586 2.992H32.72v-1.82h12.895zM48.318 40.113a.59.59 0 0 0 .414-.172l3.24-3.24a.59.59 0 0 0 0-.829l-3.24-3.24a.586.586 0 0 0-.828 0l-3.24 3.24a.586.586 0 0 0 0 .829l3.24 3.24c.11.11.258.172.414.172m0-6.238 2.411 2.411-2.411 2.412-2.411-2.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M48.319 42.277a6 6 0 0 0 5.991-5.991c-.329-7.948-11.654-7.946-11.982 0a5.997 5.997 0 0 0 5.99 5.99m0-10.81a4.824 4.824 0 0 1 4.819 4.819c-.265 6.392-9.374 6.391-9.638 0a4.824 4.824 0 0 1 4.819-4.819"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "snack_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4483_45553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4483_45553",
    result: "shape"
  })))));
};
export default SvgSnack;